import React from 'react';

const ButtonItem = ({isActive, color, title, onClick}) => (
  <div
    onClick={onClick}
    className={`rounded-full p-2.5 hover:opacity-75 shadow-current border-2 mx-1.5 text-center cursor-pointer my-1 ${isActive && 'border-2 border-primary-500'}`}
    style={{backgroundColor: color}} title={title}>
  </div>
)
const ColorButtons = ({selectedColor = {}, colors, onClick}) => (
  <div className="flex">
    {colors?.map((color) => (
      <ButtonItem isActive={selectedColor.id === color.id} key={color.id} color={color.hex} title={color.name} onClick={() => onClick(color)}/>
    ))}
  </div>
)
export default ColorButtons;
